function brandsShowcaseToggle() {
  const blocks = document.querySelectorAll(".brands-showcase");

  if (!blocks.length) return;

  blocks.forEach(block => {
    // Prevent double initialization
    if (block.dataset.toggleInitialized === "true") return;
    block.dataset.toggleInitialized = "true";

    // Get texts from data attributes
    const expandText = block.dataset.expandText || "rozwiń opis";
    const collapseText = block.dataset.collapseText || "zwiń opis";
    const items = block.querySelectorAll(
      '.brands-showcase__item[data-collapsible="true"]'
    );

    items.forEach((item, index) => {
      // Check if button already exists
      if (item.querySelector(".brands-showcase__item-toggle")) {
        return;
      }

      const toggleBtn = document.createElement("button");

      toggleBtn.className = "brands-showcase__item-toggle";
      toggleBtn.setAttribute("type", "button");
      toggleBtn.setAttribute("aria-expanded", "false");

      // Create button content
      toggleBtn.innerHTML = `
        <span class="brands-showcase__item-toggle-text">${expandText}</span>
        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M3 5L9 11L15 5" stroke="#1E2C92" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      `;

      // Add click event
      toggleBtn.addEventListener("click", function(e) {
        e.preventDefault();
        const isExpanded = item.classList.contains("is-expanded");
        const textSpan = this.querySelector(
          ".brands-showcase__item-toggle-text"
        );

        if (isExpanded) {
          // Collapse
          item.classList.remove("is-expanded");
          this.setAttribute("aria-expanded", "false");
          textSpan.textContent = expandText;
        } else {
          // Expand
          item.classList.add("is-expanded");
          this.setAttribute("aria-expanded", "true");
          textSpan.textContent = collapseText;
        }
      });

      // Append button to item
      item.appendChild(toggleBtn);
    });
  });
}

// Initialize on DOM ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", brandsShowcaseToggle);
} else {
  brandsShowcaseToggle();
}

// Re-initialize on dynamic content load (if needed)
if (typeof acf !== "undefined") {
  acf.addAction("render_block_preview", brandsShowcaseToggle);
}
